﻿import cpiStatusMessage from "../statusMessage";
import cpiLoadingSpinner from "../loadingSpinner";
import cpiConfirm from "../confirm";
import cpiPrintConfirm from "../printConfirm";
import cpiAlert from "../alert";
import ActivePage from "../activePage";
import AgentPage from "./agentPage";
import ClientPage from "./clientPage";
import OwnerPage from "./ownerPage";
import QuickDocket from "./quickDocket";
import QuickEmail from "./quickEmail";
import QuickEmailSetup from "./quickEmailSetup";
import ReportSchedulerPage from "./reportSchedulerPage";
import ReportCriteriaPage from "./reportCriteriaPage";
import AuditTrail from "./auditTrailPage";
import DataQuery from "./dataQuery";
import CustomReport from "./customReport";
import * as pageHelper from "../pageHelper";
import FamilyTreePage from "../shared/familyTreePage";
import PTOMappingPage from "./ptoMappingPage";
import DynamicGrid from "./dynamicGrid";
import FileUtility from "./fileUtility";
import DataImportPage from "./dataImportPage";
import Letter from "./letter";
import LetterSetup from "./letterSetup";
import DocumentPage from "./documentPage";
import GenSearch from "./genSearch";
import EmailSetupPage from "./emailSetupPage";
import EmailSetupDetailPage from "./emailSetupDetailPage";
import EmailTemplatePage from "./emailTemplatePage";
import GlobalSearch from "./globalSearch";
import ProductPage from "./productPage";
import ProductImportPage from "./productImportPage";
import FormExtract from "./formExtract";
import FormExtractIFW from "./formExtractIFW";

if (!window.cpiStatusMessage) {
    window.cpiStatusMessage = cpiStatusMessage;
}

if (!window.cpiLoadingSpinner) {
    window.cpiLoadingSpinner = cpiLoadingSpinner;
}

if (!window.cpiConfirm) {
    window.cpiConfirm = cpiConfirm;
}

if (!window.cpiPrintConfirm) {
    window.cpiPrintConfirm = cpiPrintConfirm;
}

if (!window.cpiAlert) {
    window.cpiAlert = cpiAlert;
}

if (!window.ActivePage) {
    window.ActivePage = ActivePage;
}

//if (!window.image) {
//    window.image = new Image();
//}

if (!window.pageHelper) {
    window.pageHelper = pageHelper;
}

if (!window.agentPage) {
    window.agentPage = new AgentPage();
}

if (!window.clientPage) {
    window.clientPage = new ClientPage();
}
if (!window.ownerPage) {
    window.ownerPage = new OwnerPage();
}
if (!window.quickDocket) {
    window.quickDocket = new QuickDocket();
}

if (!window.ReportSchedulerPage) {
    window.ReportSchedulerPage = new ReportSchedulerPage();
}
if (!window.ReportCriteriaPage) {
    window.ReportCriteriaPage = new ReportCriteriaPage();
}
if (!window.quickEmail) {
    window.quickEmail = new QuickEmail();
}
if (!window.quickEmailSetup) {
    window.quickEmailSetup = new QuickEmailSetup();
}

if (!window.auditTrail) {
    window.auditTrail = new AuditTrail();
}

if (!window.dataQuery) {
    window.dataQuery = new DataQuery();
}

if (!window.customReport) {
    window.customReport = new CustomReport();
}

if (!window.familyTreePage) {
    window.familyTreePage = new FamilyTreePage
}

if (!window.ptoMappingPage) {
    window.ptoMappingPage = new PTOMappingPage();
}

if (!window.dynamicGrid) {
    window.dynamicGrid = new DynamicGrid();
}

if (!window.fileUtility) {
    window.fileUtility = new FileUtility();
}

if (!window.dataImportPage) {
    window.dataImportPage = new DataImportPage();
}

if (!window.letter) {
    window.letter = new Letter();
}

if (!window.letterSetup) {
    window.letterSetup = new LetterSetup();
}

if (!window.documentPage) {
    window.documentPage = new DocumentPage();
}

if (!window.genSearch) {
    window.genSearch = new GenSearch();
}

if (!window.emailSetupPage) {
    window.emailSetupPage = new EmailSetupPage();
}

if (!window.emailSetupDetailPage) {
    window.emailSetupDetailPage = new EmailSetupDetailPage();
}

if (!window.emailTemplatePage) {
    window.emailTemplatePage = new EmailTemplatePage();
}

if (!window.globalSearch) {
    window.globalSearch = new GlobalSearch();
}

if (!window.productPage) {
    window.productPage = new ProductPage();
}

if (!window.productImportPage) {
    window.productImportPage = new ProductImportPage();
}

if (!window.formExtract) {
    window.formExtract = new FormExtract();
}

if (!window.formExtractIFW) {
    window.formExtractIFW = new FormExtractIFW();
}


//signalR codes
$(document).ready(function () {
    initializeSignalR();
});

function initializeSignalR() {
    const baseUrl = $("body").data("base-url");
    const connection = new signalR.HubConnectionBuilder()
        .withUrl(`${baseUrl}/notify`, {
            skipNegotiation: true,
            transport: signalR.HttpTransportType.WebSockets
        })
        .configureLogging(signalR.LogLevel.Information)
        .build();

    connection.on('refreshCount', (sender, messageText) => {
        pageHelper.getUnviewedNotifications();
    });

    connection.start()
        .then(() => console.log('SignalR connection active'))
        .catch(console.error);

    //connection.invoke('SendMessage', "message deleted...");
};



